module.exports = __webpack_public_path__ + "static/img/15C.1ca47e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15C.jpg
// module id = v6Er
// module chunks = 56